import { useState } from 'react';
import { Position } from 'reactflow';
import { BaseNode } from './BaseNode';

export const OutputNode = ({ id, data }) => {
  const [currName, setCurrName] = useState(
    data?.outputName || id.replace('customOutput-', 'output_')
  );
  const [outputType, setOutputType] = useState(data.outputType || 'Text');

  const config = {
    title: 'Output',
    fields: [
      {
        name: 'name',
        type: 'text',
        label: 'Name',
        value: currName,
        onChange: (e) => setCurrName(e.target.value),
        placeholder: 'Enter output name',
      },
      {
        name: 'type',
        type: 'select',
        label: 'Type',
        value: outputType,
        onChange: (e) => setOutputType(e.target.value),
        options: ['Text', 'Image'],
      },
    ],
    handles: [
      {
        type: 'target',
        position: Position.Left,
        id: `${id}-value`,
      },
    ],
    width: 220,
    height: 120,
  };

  return <BaseNode id={id} data={data} config={config} />;
};